module.exports = __webpack_public_path__ + "img/leftthigh-mesomorph-male.0e4535b3.svg";